/**
 * `/inloggen?terug=...` (MA-44): na het inloggen terug naar waar je vandaan kwam, zoals het
 * venster van de vanger op vanger.mamimap.nl.
 *
 * Alleen naar MamiMap zelf. Een inlogpagina die blind doorstuurt is een open redirect: een
 * link als `mamimap.nl/inloggen?terug=https://evil.example` ziet er dan vertrouwd uit en zet
 * je na het inloggen op een nagemaakte pagina. Dus: https, host `mamimap.nl` of een subdomein
 * daarvan, geen poort, geen gebruikersnaam of wachtwoord in de URL.
 */

export const TERUG_DOMEIN = 'mamimap.nl';

/** De opgeschoonde URL als hij naar MamiMap wijst, anders null. */
export function veiligTerug(ruw: string | null | undefined): string | null {
  if (!ruw) return null;
  const tekst = ruw.trim();
  // Alleen absolute https-adressen; `//evil.example` en `/\evil.example` vallen hier al af.
  if (!/^https:\/\//i.test(tekst)) return null;
  let url: URL;
  try {
    url = new URL(tekst);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:') return null;
  if (url.username !== '' || url.password !== '') return null;
  if (url.port !== '') return null;
  const host = url.hostname.toLowerCase();
  if (host !== TERUG_DOMEIN && !host.endsWith(`.${TERUG_DOMEIN}`)) return null;
  return url.toString();
}

/**
 * Een lus voorkomen. Stuurt het venster je meteen weer naar de inlog (de cookie komt daar niet
 * aan, bijvoorbeeld omdat AUTH_COOKIE_DOMEIN ontbreekt), dan zou deze pagina je eindeloos heen
 * en weer sturen. Binnen een halve minuut naar hetzelfde adres: niet nog eens.
 */
const LUS_SLEUTEL = 'mamimap:terug';
const LUS_MS = 30_000;

export function magTerugsturen(url: string, nu = Date.now()): boolean {
  try {
    const vorige = JSON.parse(window.sessionStorage.getItem(LUS_SLEUTEL) ?? 'null') as {
      url?: string;
      tijd?: number;
    } | null;
    if (vorige?.url === url && typeof vorige.tijd === 'number' && nu - vorige.tijd < LUS_MS) {
      return false;
    }
    window.sessionStorage.setItem(LUS_SLEUTEL, JSON.stringify({ url, tijd: nu }));
  } catch {
    // Geen sessionStorage (privévenster): dan maar zonder lusbeveiliging.
  }
  return true;
}
